// import { providersService } from '../services';
import { providersService } from 'services';

export const Status = async () => {
  const { data } = await providersService.getSacManagementStatus();
  return data;
};
